import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { useTranslation } from "react-i18next";

interface GearPalClusterMarkerProps {
  position: [number, number];
  zipCode: string;
  count: number;
  onClick: () => void;
  icon: L.DivIcon;
}

const GearPalClusterMarker: React.FC<GearPalClusterMarkerProps> = ({
  position,
  zipCode,
  count,
  onClick,
  icon,
}) => {
  const { t } = useTranslation();

  return (
    <Marker
      position={position}
      icon={icon}
      eventHandlers={{
        click: onClick,
      }}
    >
      <Popup className="gear-cluster-popup">
        <div className="flex flex-col items-center justify-center p-1 text-center min-w-[120px]">
          <div className="text-secondary text-2xl font-black leading-none mb-1">
            {count}
          </div>
          <div className="text-white/40 text-[9px] uppercase tracking-[0.2em] font-bold mb-2">
            {t("map.providers", "Fornitori")}
          </div>

          <div className="w-8 h-[1px] bg-white/10 mb-2" />

          <div className="flex items-center gap-1 text-white/90">
            <span className="text-[14px] font-bold tracking-tight">
              {zipCode}
            </span>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default GearPalClusterMarker;
